import { render } from "./AdminEmail.vue?vue&type=template&id=75e062c9&scoped=true"
import script from "./AdminEmail.vue?vue&type=script&lang=js"
export * from "./AdminEmail.vue?vue&type=script&lang=js"

import "./AdminEmail.vue?vue&type=style&index=0&id=75e062c9&scoped=true&lang=css"

import exportComponent from "/var/www/boa/bo/frontend/boa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75e062c9"]])

export default __exports__